/**
 * HELP-ICONS-RENDER.UTILS
 * FontAwesome icons of the guides, as SVG written in the text (done after the cleaning of the HTML : the SVG is ours)
 */
import { icon } from "@fortawesome/fontawesome-svg-core"
import {
  faArrowDown,
  faArrowUp,
  faCalculator,
  faChartLine,
  faChartPie,
  faCircle,
  faCircleCheck,
  faCircleInfo,
  faClipboardList,
  faComments,
  faEquals,
  faList,
  faLock,
  faMagnifyingGlassChart,
  faSmile,
  faTh,
  faTriangleExclamation,
  faVoteYea
} from "@fortawesome/free-solid-svg-icons"
import { HelpIconName, HelpTabIconName, replaceHelpIconTokens, replaceHelpTabIconTokens } from "@/utils/help-icons.utils"

export interface HelpAccountColors {
  low: string
  middle: string
  high: string
}

const ICONS: Record<HelpIconName, { definition: any; color: string }> = {
  rouge: { definition: faCircle, color: "#eb5a46" },
  orange: { definition: faCircle, color: "#f2b100" },
  vert: { definition: faCircle, color: "#4FD683" },
  ok: { definition: faCircleCheck, color: "#4FD683" },
  attention: { definition: faTriangleExclamation, color: "#f2b100" },
  info: { definition: faCircleInfo, color: "#8C8C8C" },
  "couleur-basse": { definition: faCircle, color: "#eb5a46" },
  "couleur-moyenne": { definition: faCircle, color: "#f2b100" },
  "couleur-haute": { definition: faCircle, color: "#4FD683" },
  //Pastille of the benchmark : the arrow and the colors of the chip of the dashboard (below, like the others, above)
  "pastille-basse": { definition: faArrowDown, color: "#eb5a46" },
  "pastille-egale": { definition: faEquals, color: "#9CA3AF" },
  "pastille-haute": { definition: faArrowUp, color: "#20CA7E" },
  //Categories of the RPS (Karasek) : the colors of the dashboard
  "rps-iso": { definition: faCircle, color: "#eb5a46" },
  "rps-job": { definition: faCircle, color: "#ff9500" },
  "rps-actif": { definition: faCircle, color: "#8c8c8c" },
  "rps-passif": { definition: faCircle, color: "#afafaf" },
  "rps-detendu": { definition: faCircle, color: "#ccc" }
}

//Same icons as the tabs of the dashboard (see SESSION_DASHBOARD_TABS), the color is the one of the account (set by the guide)
const TAB_ICONS: Record<HelpTabIconName, any> = {
  overview: faChartPie,
  participation: faVoteYea,
  questions: faList,
  matrice: faTh,
  historique: faChartLine,
  commentaires: faComments,
  nps: faSmile,
  rps: faTriangleExclamation,
  "plan-action": faClipboardList,
  calcul: faCalculator,
  confidentialite: faLock,
  benchmark: faMagnifyingGlassChart
}

export function injectHelpIcons(html: string, accountColors?: HelpAccountColors): string {
  const withTabIcons = replaceHelpTabIconTokens(html, (name) =>
    icon(TAB_ICONS[name], { classes: ["help-icon", "help-tab-icon"], attributes: { "aria-hidden": "true" } }).html[0]
  )
  return replaceHelpIconTokens(withTabIcons, (name) => {
    const { definition } = ICONS[name]
    const color =
      name === "couleur-basse" ? (accountColors?.low ?? ICONS[name].color)
      : name === "couleur-haute" ? (accountColors?.high ?? ICONS[name].color)
      : name === "couleur-moyenne" ? (accountColors?.middle ?? ICONS[name].color)
      : ICONS[name].color
    return icon(definition, { classes: ["help-icon"], styles: { color }, attributes: { "aria-hidden": "true" } }).html[0]
  })
}
